import React from 'react';
import '../../App.css';
import { redirectTo } from './../../actionSMB/redirection'
import { connect } from 'react-redux'
import ProductDetailsValue from './productDetails'
import ProductDetailsInfo from './productDetailsInfo'
import AccessoriesHeader from  '../header/accessoriesHeader';
import Faq from  '../faq/index';
import Loader from './../../componentsSMB/loader';
import {Utils} from '../../utilSMB/utils';
import { Pages } from '../../constantsSMB/actionType';
import * as productDetailsAction from './../../actionSMB/productDetailsAction';
// import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router';
import { updatePageLogs, checktime, catchJSException } from './../../serviceSMB/logService';
import ReactHtmlParser from 'react-html-parser';
import { Helmet } from "react-helmet";
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

class ProductDetails extends React.PureComponent {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            paramsValue:'',
            productsDetailsState: [],
            signIn :false
            
        }
    }
   
    componentWillMount() {
        this.props.dispatch({ type: 'PRODUCTDETAILSFROMJSON', value: null });
        const { cookies } = this.props;
        let userInfo = cookies.get('userinfo');
        if(userInfo !== undefined && userInfo !== "" && userInfo !== null){
            this.setState({signIn:true},()=>this.getProductDetails())
        }else{
            this.getProductDetails()
        }
        // const { cookies } = this.props;
        // let userInfo = cookies.get('userinfo');
        // if(userInfo !== undefined && userInfo !== "" && userInfo !== null){

        //  var promise = new Promise( (resolve, reject) => {

        //     let signedIn=this.props.categoriesState.isValidUser
          
        //     if (signedIn === true) {
        //      resolve("Promise resolved successfully");
        //     }
        //    });
          
        //    promise.then(  
        //     this.getProductDetails()
        // );
        // }else{
        //     this.getProductDetails()
        // }
        // setTimeout(()=>{this.getProductDetails()},10000)
        // this.getProductDetails()
        checktime(this.callCheckTime('WillMount'));
        // let request ={
        //     "categoryId":this.props.productstate.selectedCategoryAndProduct.categoryId,
        //     "productId": this.props.productstate.selectedCategoryAndProduct.productId,
        // }
        // productDetailsAction.getProductDetails(request,this.props.dispatch);
        // this.setState({paramsValue:this.props.props.match.params.subPageName})
    }
    getProductDetails(){
        let request
      if(this.props.productstate.pageinfo!==undefined&&(this.props.productstate.storeColorClick===undefined||
        this.props.productstate.storeColorClick===false)){
        //  if(this.props.productstate.selectedCategoryAndProduct===undefined&&this.props.productstate.storeColorClick===false){
            request={
             "categoryId":this.props.productstate.pageinfo.categoryId,
             "productId": this.props.productstate.pageinfo.productId,
             "skuId": this.props.productstate.pageinfo.skuId,
            //  "signedIn" :this.props.categoriesState.isValidUser
            "signedIn" :this.state.signIn
            }
        }else {
         request ={
             "categoryId":this.props.productstate.selectedCategoryAndProduct.categoryId,
             "productId": this.props.productstate.selectedCategoryAndProduct.productId,
             "skuId": this.props.productstate.selectedCategoryAndProduct.skuId,
            //  "signedIn" :this.props.categoriesState.isValidUser
            "signedIn" :this.state.signIn
         }
         this.props.dispatch({ type: 'STORECOLORCLICK', value: false });
        }
         productDetailsAction.getProductDetails(request,this.props.dispatch,this.props.appState.visitId,this.props.match.params.filterName);
        this.setState({paramsValue:this.props.props.match.params.pageName})
        this.processPageAfterVisitID()
    }

    // componentWillReceiveProps(nextProps){ 
    //     console.log('current props',this.props.props.match.params.pageName,nextProps.match.params.pageName)
    //        if(nextProps.match.params.pageName!==this.state.paramsValue){
    //        // if(this.props.productstate.selectedCategoryAndProduct.productId!=this.state.productId){
    //          this.setState({ paramsValue: nextProps.match.params.pageName});
    //          //this.setState({ productId: this.props.productstate.selectedCategoryAndProduct.productId});
    //          this.getProductDetails();
    //         }
            
    //         // let request ={ 
    //         //     "categoryId":this.props.productstate.selectedCategoryAndProduct.categoryId,
    //         //     "productId": this.props.productstate.selectedCategoryAndProduct.productId,
    //         // } 
    //         //  productDetailsAction.getProductDetails(request,this.props.dispatch);
    //         //  }  
    //   }

    // OnClick = ((selectedPrd) => {
    //     let redirectURL="/smallbusiness/accessories/" ;
    //     redirectURL=redirectURL+selectedPrd;
    //    redirectTo(redirectURL,this.props.dispatch)
    // })

    handleClick=(e)=>{
        try{
            e.preventDefault()
            // let redirectURL = Pages.Category  + Utils.removeSpecialChars(this.props.selectedProductCategory.groupName)
            let redirectURL = Pages.Category  + Utils.removeSpecialChars(this.props.productstate.pageinfo.seoKw) + "/";
            redirectTo(redirectURL, this.props.dispatch)
        } catch(ex){
            catchJSException('productDetails_index', this.props.appState.visitId, 'handleClick', ex);
        }
    }

    colorSelection = (productId) => {
        try{
            this.state.productsDetailsState.prodDetailsExp.products.map((groupExpitems, index) => {
                return(
                groupExpitems.items.map((itemValue, index) => {
                    if (itemValue.productId === productId) {
                        groupExpitems.selectedProd = itemValue
                        this.setState(groupExpitems.selectedProd)
                        this.setState({
                            productsDetailsState: this.state.productsDetailsState
                        })
                       productDetailsAction.productDetailsValue(this.state.productsDetailsState.prodDetailsExp, this.props.dispatch);
                       
                    }
                    return "";
                })
            )})    
        } catch(ex){
            catchJSException('productDetails_index', this.props.appState.visitId, 'colorSelection', ex);
        }
    }
    processPageAfterVisitID = () => {
        try {
            updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            checktime(this.callCheckTime('Mount'));
            // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
        }
        catch (ex) {
            catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
        }
    }
    callCheckTime = ((pagestate) => {
        return {
            page: 'productDetailspage',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })

    render() {
        let browerUrl
        let metaInfoContent
        let titleTag
        let descriptionTags
        let keywords
        if(this.props.location){
         browerUrl = Utils.getDomainUrl()+this.props.location.pathname 
        }
        if (this.state.productsDetailsState && this.state.productsDetailsState.prodDetailsExp) {
            this.state.productsDetailsState.prodDetailsExp.products.map((value, index) => {
                metaInfoContent=value.items[0].metaInfo
                titleTag=value.titleTag,
                descriptionTags=value.descriptionTags,
                keywords=value.kws
                return (titleTag,descriptionTags,keywords);
            })
           }
        let metaInfo
        if (metaInfoContent) {
            metaInfo = (
                <div >
                    <Helmet>
                    {ReactHtmlParser(metaInfoContent)}
                    <title>{ReactHtmlParser(titleTag)}</title> 
                    <meta name="description" content={descriptionTags}/>
                    <meta name="keywords" content={keywords}/>
                    </Helmet>
                </div>
            )
        }
        else{
            metaInfo = (
                <div >
                    <Helmet>
                    <link  rel="canonical" href={browerUrl}/>
                    <title>{ReactHtmlParser(titleTag)}</title> 
                    <meta name="description" content={descriptionTags}/>
                    <meta name="keywords" content={keywords}/>
                    </Helmet>
                </div>
            )
            
        }
        this.setState({paramsValue:this.props.props.match.params.pageName})
        let productDetailsInfo='';
        let accessoriesHeader=<AccessoriesHeader accessoriesHeaderValue={this.props.categoriesState} props={this.props.props}></AccessoriesHeader>
        let faq=<Faq props={this.props} />
        let productDetails='';
        let categoryName='';
        let productName='';
        // this.props.categoriesState.categoriesExp.find((value, index) => {
        //     if (this.props.productstate.selectedCategoryAndProduct.categoryId === value.categoryId) {
        //         categoryName = value.name
               
        //     }
        //     return categoryName;
        // })
        categoryName=this.props.productstate.pageinfo.categoryName
        let categoryNames = categoryName
        //let categoryNames=this.props.props.match.params.pageName
        //let categoryProps=this.props.categoriesState.categoryDetails===undefined?categoryNames:this.props.categoriesState.categoryDetails.categoryName.name
        let selectedPrd="";
        let item=''
    
        if (this.props.product && this.props.product.prodDetailsExp) {
            this.setState({
                productsDetailsState: this.props.product
            })
            if (this.state.productsDetailsState && this.state.productsDetailsState.prodDetailsExp) {
                this.state.productsDetailsState.prodDetailsExp.products.map((value, index) => {
                    item=value.items
                    selectedPrd=value.selectedProd
                    return (item ,selectedPrd);
                })
                productDetails=<ProductDetailsValue productDetailsValue={selectedPrd} item={item} colorSelection={this.colorSelection} props={this.props} />;
                productDetailsInfo=<ProductDetailsInfo productDetailsValue={selectedPrd} productValue={this.state.productsDetailsState} props={this.props} categoriesState={this.props.categoriesState} />;
            }  
            
        }


        if(Utils.isNotNull(this.props.product) && Utils.isNotEmpty(this.props.product.prodDetailsExp) && Utils.isNotEmpty(this.props.product.prodDetailsExp.products[0]) && Utils.isNotEmpty(this.props.product.prodDetailsExp.products[0].items[0])){
            categoryName=Utils.isNotEmpty(this.props.product.prodDetailsExp.products[0].items[0].categoryName)?this.props.product.prodDetailsExp.products[0].items[0].categoryName:""
            productName=Utils.isNotEmpty(this.props.product.prodDetailsExp.products[0].items[0].name)?this.props.product.prodDetailsExp.products[0].items[0].name:""
        }
        let footerDescription = Utils.isNotNull(this.props.product && this.props.product.prodDetailsExp && this.props.product.prodDetailsExp.footerDescription) ? (this.props.product.prodDetailsExp.footerDescription) : ""
        return (
            <div>
                {metaInfo}
                {accessoriesHeader}
            <main className="main padding-horiz-zero" aria-hidden="false">
				<Loader/>
                
			    <div className="p-100 inline-block" data-product-detail="">
                   {faq}
                   <div className="products-list_breadcrumb left" style={{display: "inherit", minWidth: "250px"}}>
                            <a className="margin-right-tiny" onClick={this.handleClick} href={Pages.Category  + Utils.removeSpecialChars(this.props.productstate.pageinfo.seoKw) + "/"}>{categoryNames}</a>&gt; 
                            <span className="margin-left-tiny">{productName}</span>	
                    </div>
                    <div class="margin-bottom-micro clear">&nbsp;</div>
                   <div id="divsku830086">
                   {productDetails}
                    </div>
                </div>
                <div className="w_products-description">
                    {productDetailsInfo}
                    <p class="products-description_container" >
                            {ReactHtmlParser(footerDescription)}
                    </p>
                </div>
            </main>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return { 
        appState: state.appSMB,
        product : state.prodDetailsSMB,
        categoriesState: state.categoriesSMB,
        productstate:state.productsSMB,
        selectedProductCategory:state.productsSMB.selectedCategoryDescExp
    }
}
export default withCookies(withRouter(connect(
    mapStateToProps
)(ProductDetails)));

//export default Accessories;